// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__CDRQx","loaderOuter":"PageOverlayLoader_loaderOuter__359a4"};